import axios from "axios";
import { useCallback, useEffect, useState } from "react";
import { NavLink } from "react-router-dom";

function Sidebar() {

   const [firstLetter, setFirstLetter] = useState("R"); // fallback

   const [unreadCount, setUnreadCount] = useState(0);
     const API_BASE = process.env.REACT_APP_API_BASE;
     const token = localStorage.getItem("authToken");
   
     const fetchUnreadCount = useCallback(async () => {
       try {
         if (!token) return;
    
    
         const res = await axios.get(`${API_BASE}/user/chat-hosts`, {
           headers: { Authorization: `Bearer ${token}` },
         });
    
    
         const chats = res.data?.data || [];
         const totalUnread = chats.reduce(
           (sum, chat) => sum + (Number(chat.unread_count) || 0),
           0
         );
         setUnreadCount(totalUnread);
       } catch (err) {
         console.error("Error fetching unread count:", err);
       }
     }, [API_BASE, token]);
    
     useEffect(() => {
       fetchUnreadCount();
       const interval = setInterval(fetchUnreadCount, 5000);
       return () => clearInterval(interval);
     }, [fetchUnreadCount]);
    
    
    
     useEffect(() => {
       const handleUnreadChange = () => fetchUnreadCount();
       window.addEventListener("unreadCountUpdated", handleUnreadChange);
       return () =>
         window.removeEventListener("unreadCountUpdated", handleUnreadChange);
     }, [fetchUnreadCount]);

  useEffect(() => {
    const userData = localStorage.getItem("user"); // 🔹 key must match how you store it
    if (userData) {
      try {
        const parsed = JSON.parse(userData);
        // if (parsed.first_name) {
        //   set
        // FirstLetter(parsed.first_name.charAt(0).toUpperCase());
        // }
         if (parsed.first_name && parsed.first_name.trim() !== "") {
          setFirstLetter(parsed.first_name.charAt(0).toUpperCase());
        } else if (parsed.email) {
          setFirstLetter(parsed.email.charAt(0).toUpperCase());
        }

      } catch (error) {
        console.error("Error parsing user data:", error);
      }
    }
  }, []);
  return (
    <>
	<div className="col-lg-3 col-sm-5 mb_view_hide">
      <div className="user_allls profiles pt-0 pb-0">
            
              <div className="prfo_listst">
                <h4>Dashboard</h4>
                <ul>
                  <li>
                    <NavLink to={'profile'}  end className={({ isActive }) => (isActive ? "action" : "")}>
                      <span className="titl"><img src="/images/person.png" alt="" /></span> About Me
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to={'user-experience'} className={({ isActive }) => (isActive ? "action" : "")}>
					  <span className="titl"><img src="/images/experiences.png" alt="" /></span> Experience
					 </NavLink>
                  </li>
                  <li>
                    <NavLink to={'user-wishlist'} className={({ isActive }) => (isActive ? "action" : "")}>
					 <span className="titl"><img src="/images/favourite.png" alt="" /></span> Wishlist
					 </NavLink>
           
                  </li>
                  <li>
                    <NavLink to={'chat'} className={({ isActive }) => (isActive ? "action" : "")}>
					 <span className="titl"><img src="/images/bx_message.png" alt="Mesage" /></span>{unreadCount > 0 && (
                            <span className="usr_msg_counts">
                              {unreadCount > 9 ? "9+" : unreadCount}
                            </span>
                          )} Message
					 </NavLink>
           
                  </li>
                  
                  
                    <li>
                    <NavLink to={'notification'} className={({ isActive }) => (isActive ? "action" : "")}>
					 <span className="titl"><img src="/images/bell_ic.png" alt="" /></span> Notification
					</NavLink>
                  </li>
                    <li>
                    <NavLink to={'user-setting'} className={({ isActive }) => (isActive ? "action" : "")}>
					 <span className="titl"><img src="/images/setting_ic.png" alt="" /></span> Setting
					</NavLink>
                  </li>
                </ul>
              </div>
            </div>
      </div>
    </>
  );
}

export default Sidebar;
